import { createActions, createReducer } from 'reduxsauce';

const { Types, Creators } = createActions(
  {
    // Businesses
    getBusinesses: [],
    getBusinessesRequest: [],
    getBusinessesSuccess: ['businesses'],
    getBusinessesFailure: ['error'],

    // Products
    getProducts: [],
    getProductsRequest: [],
    getProductsSuccess: ['products'],
    getProductsFailure: ['error'],

    // Promotions
    getPromotions: ['advertiserId'],
    getPromotionsRequest: [],
    getPromotionsSuccess: ['promotions'],
    getPromotionsFailure: ['error'],
  },
  { prefix: 'cb/awin/' }
);

export const INITIAL_STATE = {
  businesses: [],
  products: [],
  promotions: [],
  loading: {
    businesses: false,
    products: false,
    promotions: false,
  },
  error: {
    businesses: null,
    products: null,
    promotions: null,
  },
};

export const HANDLERS = {
  // BUSINESSES
  [Types.GET_BUSINESSES_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, businesses: true },
    error: { ...state.error, businesses: null },
  }),
  [Types.GET_BUSINESSES_SUCCESS]: (state, { businesses }) => ({
    ...state,
    loading: { ...state.loading, businesses: false },
    businesses,
  }),
  [Types.GET_BUSINESSES_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, businesses: false },
    error: { ...state.error, businesses: error },
  }),

  // PRODUCTS
  [Types.GET_PRODUCTS_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, products: true },
    error: { ...state.error, products: null },
  }),
  [Types.GET_PRODUCTS_SUCCESS]: (state, { products }) => ({
    ...state,
    loading: { ...state.loading, products: false },
    products,
  }),
  [Types.GET_PRODUCTS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, products: false },
    error: { ...state.error, products: error },
  }),

  // PROMOTIONS
  [Types.GET_PROMOTIONS_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, promotions: true },
    error: { ...state.error, promotions: null },
  }),
  [Types.GET_PROMOTIONS_SUCCESS]: (state, { promotions }) => ({
    ...state,
    loading: { ...state.loading, promotions: false },
    promotions,
  }),
  [Types.GET_PROMOTIONS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, promotions: false },
    error: { ...state.error, promotions: error },
  }),
};

export default createReducer(INITIAL_STATE, HANDLERS);
export { Types as types, Creators as actions };